module.exports = __webpack_public_path__ + "static/media/longsPeak_usa.0a35e7eb.jpg";